<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('androidMessageSet.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="title-box">
                <div class="title">{{ $t('androidMessageSet.p0') }}</div>
                <div class="title-text">{{ $t('androidMessageSet.p1') }}</div>
            </div>

            <div class="text">{{ $t('androidMessageSet.p2') }} <span class="bold">{{ $t('androidMessageSet.p3') }}</span>
                {{ $t('androidMessageSet.p4') }} <span class="bold">{{ $t('androidMessageSet.p5') }}</span>
                {{ $t('androidMessageSet.p6') }}
            </div>
            <div class="text">{{ $t('androidMessageSet.p7') }}<span class="bold">{{
                    $t('androidMessageSet.p8')
                }}</span>{{ $t('androidMessageSet.p8end') }}
            </div>
            <img :src="require(`@/assets/theme/light/article/androidMessageSet/a1${l}.png`)">
            <div class="text">{{ $t('androidMessageSet.p9') }}<span class="bold">{{
                    $t('androidMessageSet.p10')
                }}</span>{{ $t('androidMessageSet.p11') }}
            </div>
            <div class="text">{{ $t('androidMessageSet.p12') }}<span class="bold">{{
                    $t('androidMessageSet.p13')
                }}</span>{{ $t('androidMessageSet.p14') }}<span class="bold"> {{
                    $t('androidMessageSet.p15')
                }} </span>{{ $t('androidMessageSet.p16') }}<span class="bold">{{ $t('androidMessageSet.p17') }}</span>
                {{ $t('androidMessageSet.p18') }}
            </div>
            <div class="text">{{ $t('androidMessageSet.p19') }}<span class="bold"> {{ $t('androidMessageSet.p20') }} </span>
                {{ $t('androidMessageSet.p21') }}
            </div>
            <img :src="require(`@/assets/theme/light/article/androidMessageSet/a2${l}.png`)">
            <div class="text">{{ $t('androidMessageSet.p22') }}<span class="bold"> {{ $t('androidMessageSet.p23') }} </span>{{
                    $t('androidMessageSet.p24')
                }} <span class="bold"> {{ $t('androidMessageSet.p25') }} </span>{{ $t('androidMessageSet.p26') }}<span
                    class="bold"> {{ $t('androidMessageSet.p27') }}</span>{{ $t('androidMessageSet.p28') }} <span
                    class="bold">{{ $t('androidMessageSet.p29') }}</span>{{ $t('androidMessageSet.p30') }}
            </div>
            <img :src="require(`@/assets/theme/light/article/androidMessageSet/a3${l}.png`)">
            <div class="text">{{ $t('androidMessageSet.p31') }}<span class="bold">{{
                    $t('androidMessageSet.p32')
                }}</span>{{ $t('androidMessageSet.p33') }} <span class="bold">{{ $t('androidMessageSet.p34') }}</span>
                {{ $t('androidMessageSet.p35') }} <span class="bold">{{ $t('androidMessageSet.p36') }}</span>
                {{ $t('androidMessageSet.p37') }}
            </div>
            <div class="text">{{ $t('androidMessageSet.p38') }}<span class="bold"> {{ $t('androidMessageSet.p39') }} </span>
                {{ $t('androidMessageSet.p40') }} <span class="bold">{{ $t('androidMessageSet.p41') }}</span>
                {{ $t('androidMessageSet.p42') }} <span class="bold">{{ $t('androidMessageSet.p43') }}</span>
                {{ $t('androidMessageSet.p44') }}
            </div>
            <img :src="require(`@/assets/theme/light/article/androidMessageSet/a4${l}.png`)">
            <div class="text">{{ $t('androidMessageSet.p45') }} <span class="bold">{{ $t('androidMessageSet.p46') }}</span>
                {{ $t('androidMessageSet.p47') }} <span class="bold">{{
                        $t('androidMessageSet.p48')
                    }}</span>{{ $t('androidMessageSet.p49') }} <span class="bold">{{
                        $t('androidMessageSet.p50')
                    }}</span>{{ $t('androidMessageSet.p51') }}
            </div>
            <img :src="require(`@/assets/theme/light/article/androidMessageSet/a5${l}.png`)">
            <div class="text" @click="toKeepAlive">
                {{ $t('androidMessageSet.p52') }}
            </div>
            <br>
            <div class="text">
                {{ $t('androidMessageSet.p53') }}
            </div>
            <br>
            <div class="text">
                {{ $t('androidMessageSet.p54') }}
            </div>
            <br>
            <div class="text">
                {{ $t('androidMessageSet.p55') }}
            </div>
            <div class="text">
                {{ $t('androidMessageSet.p56') }}
            </div>
        </div>
    </div>
</template>

<script>
import {getQueryVariable} from '@/utils/comment'
import {WebJSBridge} from "../../utils/JSBridge1";

export default {
    name: 'androidMessageSet',
    data() {
        return {
            theme: getQueryVariable("theme") ? getQueryVariable("theme") : "light",
            l: getQueryVariable("lang") == 'en' ? "en" : "",
        }
    },
    methods: {
        back() {
            WebJSBridge.call("closeWeb", null, function (res) {
            });
        },
        toKeepAlive() {
            this.$router.push({
                name: 'keepAlive',
                query: {
                    lang: this.$i18n.locale
                }
            })
        }
    }
}
</script>

<style scoped>
.banner {
    background-color: var(--bg-color-2) !important;
}

.content {
    background: var(--bg-color-2) !important;
    padding-bottom: 20px;
}

.title-box {
    margin: 0 12px 5px;
    width: 351px;
    background: var(--bg-color-1);
    border-radius: 6px 6px 6px 6px;
}

.title {
    padding-top: 9px;
    margin: 0 9px;
    font-size: 12px;
    font-weight: bold;
    line-height: 20px;
}

.title-text {
    font-size: 12px;
    line-height: 20px;
    margin: 0 9px;
    padding-bottom: 5px;
}

.text {
    margin: 0 21px;
    font-size: 12px;
    line-height: 20px;
}

.bold {
    font-weight: bold;
}

.content img {
    width: 345px;
    margin-left: 15px;
}

.i6 {
    width: 160px;
    margin-left: 107px;
    margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/article/androidMessageSet.vue